import { j as l } from "./jsx-runtime-e6RZPHeG.js";
import { memo as c } from "react";
const i = ({
  title: e,
  titleId: o,
  ...s
}) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...s,
    children: [
      e ? /* @__PURE__ */ l.jsx("title", { id: o, children: e }) : null,
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m742.17 656.779-19.584 115.413c0 54.421-94.891 98.539-211.947 98.539s-211.925-44.117-211.925-98.539l-20.672-121.728-.725-4.203c28.864 41.301 122.389 71.573 233.323 71.573 110.997 0 204.544-30.293 233.387-71.637l-1.856 10.581zm65.792-387.542c0-54.443-133.12-98.581-297.323-98.581s-297.301 44.139-297.301 98.581l54.464 320.853c23.339 44.8 123.2 78.485 242.837 78.485 120.256 0 220.288-34.069 242.965-79.189zM513.284 605.835c-53.76 0-97.365-43.093-97.365-96.256s43.605-96.256 97.365-96.256 97.344 43.093 97.344 96.256-43.584 96.256-97.344 96.256m-2.645-298.987c-108.971 0-197.312-18.944-197.312-42.304s88.341-42.325 197.312-42.325c108.971 0 197.333 18.965 197.333 42.325s-88.363 42.304-197.333 42.304m53.323 202.733c0 27.669-22.677 50.112-50.688 50.112-27.989 0-50.688-22.443-50.688-50.112s22.699-50.112 50.688-50.112c28.011 0 50.688 22.443 50.688 50.112",
          clipRule: "evenodd"
        }
      )
    ]
  }
), t = c(i);
export {
  t as default
};
